var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gmaps-component"},[(_vm.showSearch && !_vm.existsOnlyOneHub)?_c('div',{staticClass:"gmaps-component__top-elements map-ui-element"},[_c('div',{staticClass:"gmaps-component__search-wrapper"},[_vm._m(0),_c('gmap-autocomplete',{staticClass:"introInput",attrs:{"placeholder":_vm.$t('inputAndButtons.search')},on:{"place_changed":_vm.gmapAutocompleteSetPlace}})],1)]):_vm._e(),_c('div',{staticClass:"gmaps-component__bottom-buttons map-ui-element"},[_c('transition-group',{attrs:{"name":"fade"}},[(_vm.showAllButtons)?_c('div',{key:'selected-address',class:[
              'btn',
              'btn-round',
              'btn-sm',
              'confirm-btn',
              'max-width',
              'btn-primary',
              'pre-formatted',
              {
                'btn-primary btn-inverse': !_vm.isHubSelected
                }
             ],on:{"click":_vm.centerInHub}},[_vm._v(_vm._s(_vm.selectedAddress))]):_vm._e(),(_vm.showAllButtons && _vm.showConfirmButton && !_vm.existsOnlyOneHub)?_c('div',{key:'confirmHub',class:[
              'btn btn-round',
              'btn-xs',
              'btn-tertiary',
              'confirm-btn',
              {
                'btn-disabled': !_vm.isHubSelected
              }
            ],on:{"click":_vm.confirmHub}},[_vm._v(_vm._s(_vm.$t('maps.confirm')))]):(_vm.showAllButtons && _vm.showBackButton)?_c('div',{key:'back',class:[
              'btn btn-round',
              'btn-xs',
              'btn-tertiary',
              'confirm-btn' ],on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('maps.back')))]):_vm._e()])],1),_c('div',{staticClass:"gmaps-component__user-position map-ui-element",style:(("background-image: url('" + (require('./icons/mylocation-sprite-cookieless-v2-1x.png')) + "')")),on:{"click":_vm.centerMapInUser}},[_vm._v(" $t('maps.back') ")]),_c('GmapMap',{ref:"mapRef",staticClass:"gmaps-component__map-wrapper",attrs:{"zoom":_vm.zoom,"center":_vm.mapCentroid,"options":{
         zoomControl: false,
         mapTypeControl: false,
         scaleControl: false,
         streetViewControl: false,
         rotateControl: false,
         fullscreenControl: false,
         disableDefaultUi: true
       }}},_vm._l((_vm.hubList),function(hub){return _c('Markers',{key:hub.id,attrs:{"hub":hub,"selected":_vm.selectedHub.id === hub.id,"markerClick":_vm.markerClick}})}),1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('i',{staticClass:"fas fa-search search-icon"})])}]

export { render, staticRenderFns }